"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "barzio": {
    "b3661449": [{
      "hkey": "cfdfc5e9",
      "slug": "barzio",
      "name": "Barzio",
      "primary": true,
      "skipSearch": false
    }],
    "piani-di-bobbio": [{
      "hkey": "cfdfc5e9",
      "slug": "barzio",
      "name": "Barzio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bc6c48fd": [{
      "hkey": "cfdfc5e9",
      "slug": "barzio",
      "name": "Barzio",
      "primary": true,
      "skipSearch": false
    }],
    "rifugio-lecco": [{
      "hkey": "cfdfc5e9",
      "slug": "barzio",
      "name": "Barzio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "151b90de": [{
      "hkey": "cfdfc5e9",
      "slug": "barzio",
      "name": "Barzio",
      "primary": true,
      "skipSearch": false
    }],
    "rifugio-ratti": [{
      "hkey": "cfdfc5e9",
      "slug": "barzio",
      "name": "Barzio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;